import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import ModifierCotisation from './modifierCotisation';
import GestionJoueurCotisation from './gestionJoueur.Cotisation';

function GestionAffichage(props) {

  return (
    <>
      {props.cotisation && (
        <Tabs defaultActiveKey="teamInfo" id="uncontrolled-tab-example">
          <Tab eventKey="teamInfo" title="Informations de l'équipe">
            <ModifierCotisation infoCotisation={props.cotisation.infoCotisation} userData={props.userData}/>
          </Tab>
          <br/>
          <Tab eventKey="playerInfo" title="Informations des joueurs">
            <GestionJoueurCotisation cotisationJoueur={props.cotisation.cotisationJoueur} userData={props.userData}/>
          </Tab>
        </Tabs>
      )}
    </>
  );
}

export default GestionAffichage;
